import { create, all } from 'mathjs';

const config = {
  number: 'BigNumber',
  precision: 20
}

const math = create(all, config);

export function toFineFixed(x) {
  return math.bignumber(x).toFixed();
}

export function calcDelta(x, y) {
  return math.subtract(math.bignumber(x), math.bignumber(y))
}

export const calc = (props) => {
  const { direction, value, rate, precisions, operation } = props;

  if (value === "" || value === undefined) { return { fromSum: "", toSum: "" } }

  let sumValue = `${value}`.replaceAll(' ', '');
  var result = 0;
  const realPrec = sumValue.split(".")[1];
  if (direction === "fromSum") {
    if (realPrec && (realPrec.length > precisions.from)) {
      sumValue = math.round(sumValue, precisions.from);
    }
    if (operation === "MUL") {
      result = math.round(math.multiply(math.bignumber(sumValue), math.bignumber(rate)), precisions.to);
    } else if (operation === "DIV") {
      result = math.round(math.divide(math.bignumber(sumValue), math.bignumber(rate)), precisions.to);
    }
    return { fromSum: sumValue, toSum: result, isReverse: 0 };
  } else {
    if (realPrec && (realPrec.length > precisions.to)) {
      sumValue = math.round(sumValue, precisions.to);
    }
    if (operation === "DIV") {
      result = math.round(math.multiply(math.bignumber(sumValue), math.bignumber(rate)), precisions.from);
    } else if (operation === "MUL") {
      result = math.round(math.divide(math.bignumber(sumValue), math.bignumber(rate)), precisions.from);
    }
    return { fromSum: result, toSum: sumValue, isReverse: 1 };
  }
}
